

<template>

    <div class="col-md-12">
        <b-overlay :show="showoverlay" rounded="sm" class="no-shadow trz_overlay">
            <b-form id="waiverForm"  @submit.stop.prevent="onSubmit">


                <div class="loan-card-title">
                    Waive Interest Claim
                </div>

               <div class="clearfix border loan_card_wrapper rounded mb-3 mr-3 mb-0 col-md-12">
                    <b-form-group id="interest_waiver-group" label="Waive PF interest claim from following date:" label-for="interest_waiver">
                        <!-- <b-input-group class="mb-3"> -->
                        <!-- <b-input-group class="mb-3" v-if="isWaiverDate"> --> <!-- Rejwan: 29-01-2025 -->
                        <b-input-group class="mb-3" v-if="isWaiverDate && !disableWaiveRevive"> <!-- Rejwan: 24-03-2025 -->
                            <b-input-group-append>
                                <!-- <b-form-input id="interest_waiver"  :disabled="disableme" name="interest_waiver" v-model="fdata.profit_waiver_from" v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('interest_waiver')" aria-describedby="interest_waiver-feedback" data-vv-as="Waiver Interest"></b-form-input>
                                <b-form-datepicker id="day_one" button-only right locale="en-US" :min="date_min" :disabled="disableme"   v-model="fdata.profit_waiver_from"></b-form-datepicker> -->

                                <!-- Start: Rejwan: 29-01-2025 -->
                                <div class="month-year-picker" ref="pickerWrapper">
                                    <!-- Trigger Button (acts like an input) -->
                                    <div class="date-picker" @click="togglePicker">
                                        {{ formatted_profit_waiver_from || 'Select Month & Year' }}
                                    </div>

                                    <!-- Calendar Picker -->
                                    <div v-if="showPicker" class="picker-container">
                                        <div class="picker-header">
                                            <button @click.prevent="prevYear" :class="{ 'disabled-button': isPrevYearDisabled }" :disabled="isPrevYearDisabled">&lt;</button>
                                            <span>{{ selectedYear }}</span>
                                            <button @click.prevent="nextYear">&gt;</button>
                                        </div>

                                        <div class="months-grid">
                                            <div :disabled="isMonthDisabled(index)" v-for="(month, index) in months" :key="index" :class="{ 'selected': selectedMonth === index, 'disabled': isMonthDisabled(index) }" @click="selectMonth(index)">
                                            {{ month }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- End: Rejwan: 29-01-2025 -->
                            </b-input-group-append>
                            <b-form-invalid-feedback style="display:block;" id="interest_waiver-feedback">{{ veeErrors.first('interest_waiver') }}</b-form-invalid-feedback>
                        </b-input-group>
                        <!-- Start: Rejwan: 29-01-2025 -->
                        <p v-else> {{ formatDate(fdata.profit_waiver_from) }} </p>
                        <!-- End: Rejwan: 29-01-2025 -->
                    </b-form-group>
                </div>

                <template v-if="show_waiver_revive">
                    <div class="loan-card-title">
                        Revive Interest Claim
                    </div>
                    <div class="clearfix border loan_card_wrapper rounded mb-3 mr-3 mb-0 col-md-12">
                    <!-- <b-form-group id="change-next-deduction-month-group"> -->
                    <b-form-group id="change-next-deduction-month-group" v-if="!disableWaiveRevive"> <!-- Rejwan: 24-03-2025 -->
                        <b-form-checkbox id="checkbox-1" v-model="revive_waiver" name="revive_waiver" value=1 unchecked-value=0 >
                        Revive interest claim
                        </b-form-checkbox>
                    </b-form-group>
                    <template v-if="revive_waiver > 0">
                        <b-form-group id="revive_waiver-group" label="Revive PF interest claim from following date:" label-for="revive_waiver">
                            <!-- <b-input-group class="mb-3"> -->
                            <!-- <b-input-group class="mb-3" v-if="!isWaiverDate"> --> <!-- Rejwan: 29-01-2025 -->
                            <b-input-group class="mb-3" v-if="!disableWaiveRevive"> <!-- Rejwan: 24-03-2025 -->
                                <b-input-group-append>
                                    <!-- <b-form-input id="revive_waiver"  name="revive_waiver" v-model="fdata.profit_revive_from" v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('interest_waiver')" aria-describedby="interest_waiver-feedback" data-vv-as="Waiver Interest"></b-form-input>
                                    <b-form-datepicker id="day_one" button-only right locale="en-US" min="2023-01-01"   v-model="fdata.profit_revive_from"></b-form-datepicker> -->

                                    <!-- Start: Rejwan: 29-01-2025 -->
                                    <div class="month-year-picker" ref="pickerWrapper">
                                        <!-- Trigger Button (acts like an input) -->
                                        <div class="date-picker" @click="reviveTogglePicker">
                                            {{ formatted_profit_revive_from || 'Select Month & Year' }}
                                        </div>

                                        <!-- Calendar Picker -->
                                        <div v-if="revive_show_picker" class="picker-container">
                                            <div class="picker-header">
                                                <button @click.prevent="revivePrevYear" :class="{ 'disabled-button': isRevivePrevYearDisabled }" :disabled="isRevivePrevYearDisabled">&lt;</button>
                                                <span>{{ reviveSelectedYear }}</span>
                                                <button @click.prevent="reviveNextYear">&gt;</button>
                                            </div>

                                            <div class="months-grid">
                                                <div :disabled="isReviveMonthDisabled(index)" v-for="(month, index) in months" :key="index" :class="{ 'selected': reviveSelectedMonth === index, 'disabled': isReviveMonthDisabled(index) }" @click="selectReviveMonth(index)">
                                                {{ month }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- End: Rejwan: 29-01-2025 -->
                                </b-input-group-append>
                                <b-form-invalid-feedback style="display:block;" id="revive_waiver-feedback">{{ veeErrors.first('revive_waiver') }}</b-form-invalid-feedback>
                            </b-input-group>
                            <!-- Start: Rejwan: 29-01-2025 -->
                            <p v-else>{{ formatDate(fdata.profit_revive_from) }}</p>
                            <!-- End: Rejwan: 29-01-2025 -->
                        </b-form-group>
                    </template>
                    </div>

                </template>


            <!-- <b-modal id="confirm-modal" :title="title" hide-footer>
                <br />
                <div style="height: 10px;clear:both;"> &nbsp;</div>
                <b-button class = "mt-1" type="submit"  variant="primary">{{ btn_title }}<span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></b-button>
                &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('confirm-modal')">Cancel</a>
                <div style="height: 5px;clear:both;"> &nbsp;</div>
            </b-modal> -->
            <!-- <b-button class = "mt-1" type="submit"  variant="primary">Apply</b-button> -->
             <div class="col-md-12 text-center">
                <b-button v-if="!disableWaiveRevive" class = "mt-1" variant="primary" href="javascript:void(0);" @click="showApproveModal()">Apply</b-button> <!-- Rejwan: 24-03-2025 -->
            </div>
            </b-form>

        </b-overlay>

         <!-- Start: Rejwan: 24-03-2025 -->
        <div>
            <b-modal id="pass-modal" title="Are you sure to Apply?" hide-footer>
                <span v-if="isWaiverDate">You are about to waive profit for this PF Schedule. As per policy, any profit earned for this PF Schedule starting from the waiver month will be surrendered from this PF schedule. Are you sure you wish to continue?</span>
                <span v-else>You are about to reclaim profit for this PF Schedule. As per policy, any profit earned for this PF Schedule starting from the reclaim month will be returned to this PF schedule. Are you sure you wish to continue?</span>
                <br>
            <br />
            <b-button class="btn btn-primary btn-full-width" @click="submitForm" >Confirm <span v-if="loading != ''"><img :src="pgurl+'/images/loading.gif'" width="20"></span></b-button>
    &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('pass-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
            </b-modal>

        </div>
        <!-- End: Rejwan: 24-03-2025 -->

    </div>
</template>

<script>
    export default{

        mounted() {
            // Start: Rejwan: 29-01-25
            // following is for waiver
            axios.get(this.$api_url+'/pf/employee/profit-waiver', {
                params: {
                    employee_id: this.employee_info.employee_id,
                }
            }).then(function (response) {
                if (response.data.success == true && response.data.data.profit_revive_from != '0000-00-00') {
                    this.minDate = new Date(response.data.data.profit_revive_from);
                    const waiver_min_date = new Date(response.data.data.profit_revive_from);
                    const year = waiver_min_date.getFullYear();
                    const month = String(waiver_min_date.getMonth() + 1).padStart(2, '0');
                    this.formattedMinDate = `${year}-${month}`;
                    this.selectedYear = year;
                    this.isWaiverDate = true;
                    this.disableWaiveRevive = true; // Rejwan: 24-03-2025

                } else if(response.data.success == true && response.data.data.profit_revive_from == '0000-00-00') {
                    this.isWaiverDate = false;

                } else if(this.employee_info.PF_enrollment_date){
                    this.minDate = new Date(this.employee_info.PF_enrollment_date);
                    const employee_pf_date = new Date(this.employee_info.PF_enrollment_date);
                    const year = employee_pf_date.getFullYear();
                    const month = String(employee_pf_date.getMonth() + 1).padStart(2, '0');
                    this.formattedMinDate = `${year}-${month}`;
                    this.selectedYear = year;
                }
            }.bind(this)).catch(function (error){alert(error)});
            // End: following is for waiver


            // Start: following is for reviver
            axios.get(this.$api_url+'/pf/employee/profit-revive-date' , {
                params: {
                    employee_id: this.employee_info.employee_id
                }
            }).then(function(response){
                if(response.data) {
                    this.min_revive_date = new Date(response.data);
                    this.reviveSelectedYear = this.min_revive_date.getFullYear();
                }
            }.bind(this)).catch(function (error){alert(error)});
            // End: following is for reviver

            document.addEventListener('click', this.handleClickOutside);
            // End: Rejwan: 29-01-25
        },

        // Start: Rejwan: 29-01-2025
        beforeUnmount() {
            document.removeEventListener('click', this.handleClickOutside);
        },

        computed: {
            isPrevYearDisabled() {
                // const minDate = new Date(this.employee_info.PF_enrollment_date);
                // const year = minDate.getFullYear();
                const minDate = new Date(this.minDate);
                const year = minDate.getFullYear();
                return this.selectedYear <= year;
            },
            isRevivePrevYearDisabled() {
                const year = this.min_revive_date.getFullYear();
                return this.reviveSelectedYear <= year;
            }
        },
        // End: Rejwan: 29-01-2025

        props: ['employee_info','pageurl','store_scope'],
        data(){
            const now = new Date()
            const minDate = new Date(this.employee_info.PF_enrollment_date);

            // Start: Rejwan: 29-01-2025
            const year = minDate.getFullYear();
            const month = String(minDate.getMonth() + 1).padStart(2, '0'); // Adding 1 because getMonth() is 0-indexed
            const formattedMinDate = `${year}-${month}`;
            const currentDate = new Date();
            // End: Rejwan: 29-01-2025

            return {
                // date_min:minDate, // Rejwan: 29-01-2025
                showoverlay : true,
                disableme : false,
                show_waiver_revive : false,
                fdata : {profit_waiver_from:null,profit_revive_from:null,employee_id:this.employee_info.employee_id,store_scope:this.store_scope},
                respData:[],
                revive_waiver:0,
                forgo_waiver:0,
                title:'',
                btn_title:'',
                loading:'',

                // Start: Rejwan: 29-01-2025
                date_min: formattedMinDate,
                formatted_profit_waiver_from: null,
                formatted_profit_revive_from: null,
                min_revive_date: null,
                selectedYear: currentDate.getFullYear(),
                reviveSelectedYear: null,
                selectedMonth: null,
                reviveSelectedMonth: null,
                selectedDate: '',
                showPicker: false,
                revive_show_picker: false,
                months: [
                    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
                ],
                isWaiverDate: true,
                minDate: null,
                // End: Rejwan: 29-01-2025

                 disableWaiveRevive: false, // Rejwan: 24-03-2025
            }
        },

        methods:{
            submitMyForm()
            {
                document.getElementById("waiverForm").submit();
            },
            resetForm()
            {

                this.fdata = {profit_waiver_from:null,profit_revive_from:null,employee_id:this.employee_info.employee_id,store_scope:this.store_scope};
                this.$nextTick(() => {
                    this.$validator.reset();
                });

            },
            validateState(ref)
            {
                if ( this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated) )
                {

                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            showConfirmModal: function(profit_waiver_from,revive_waiver)
            {
                this.loading = '';
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    if(revive_waiver==1)
                    {
                        this.title = 'Are you sure you want to Revive your Interest Claim ?';
                        this.btn_title = 'Apply';

                    }
                    else
                    {
                        this.title = 'Are you sure you want to Waive your Interest Claim ?';
                        this.btn_title = 'Apply';
                    }
                    this.$bvModal.show('confirm-modal');
                });
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;

                this.loading = 'loading';
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    e.preventDefault();
                    // if(this.fdata.profit_waiver_from != null)
                    // {
                    //     const minWaiverDate = new Date(this.fdata.profit_waiver_from);
                    // }

                    let currentObj = this;
                    currentObj.errormsg = '';
                    let formData = new FormData();

                    // Start: Rejwan: 29-01-2025
                    if(this.isWaiverDate) {
                        this.fdata.profit_revive_from = null;
                    }
                    // End: Rejwan: 29-01-2025

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    }
                    formData.append('revive_waiver', this.revive_waiver);

                    this.showoverlay = true;
                    axios.post(this.$api_url+'/pf/waiver/save', formData)
                        .then(function (response)
                        {

                            this.$bvToast.toast("Saved!", {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                            this.$emit('childToParent');
                            this.showoverlay = false;

                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.showoverlay = false;
                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                            for (var data in currentObj.errormsg)
                            {
                                var msg = currentObj.errormsg[data];
                                currentObj.$bvToast.toast(msg, {
                                    title: `Error`,
                                    variant: 'danger',
                                    solid: true
                                });
                                currentObj.$validator.reset();
                            }
                        });
                });
            },
            getWaiverInfo:function(employee_id)
            {

                if(!this.checkNet()) return false;

                    this.resetForm();

                    axios.get(this.$api_url+'/pf/waiver' , {
                        params: {
                            employee_id: employee_id
                        }
                    })
                    .then(function(response){
                        this.respData = response.data;


                        if(this.respData.id != null)
                        {

                            this.fdata = response.data;
                            this.fdata.store_scope = this.store_scope;

                            if(this.fdata.profit_waiver_from != '0000-00-00' && this.fdata.profit_waiver_from != null)
                            {

                                this.disableme = true;
                                this.show_waiver_revive = true;
                                //  this.formatted_profit_waiver_from = this.fdata.profit_waiver_from.slice(0, 7); // Rejwan: 29-01-2025
                            }
                            else
                            {
                                this.fdata.profit_waiver_from = null;
                            }
                            if(this.fdata.profit_revive_from == '0000-00-00')
                            {
                                this.fdata.profit_revive_from = null;
                            }
                            else
                            {
                                this.formatted_profit_revive_from = this.fdata.profit_revive_from.slice(0, 7); // Rejwan: 29-01-2025
                                this.revive_waiver = 1;
                            }
                        }
                        else
                        {

                        }
                        this.showoverlay = false;

                    }.bind(this)).catch(function (error){alert(error)});
            },

             // Start: Rejwan: 29-01-2025

            togglePicker() {
                this.showPicker = !this.showPicker;
            },
            reviveTogglePicker() {
                this.revive_show_picker = !this.revive_show_picker;
            },
            prevYear() {
                this.selectedYear--;
            },
            revivePrevYear() {
                this.reviveSelectedYear--;
            },
            nextYear() {
                this.selectedYear++;
            },
            reviveNextYear() {
                this.reviveSelectedYear++;
            },

            selectMonth(monthIndex) {
                this.selectedMonth = monthIndex;
                this.formatted_profit_waiver_from = `${this.selectedYear}-${String(monthIndex + 1).padStart(2, '0')}`;
                this.fdata.profit_waiver_from = this.formatted_profit_waiver_from + "-01";
                this.showPicker = false; // Hide the picker after selecting a date
            },

            selectReviveMonth(monthIndex) {
                this.reviveSelectedMonth = monthIndex;
                this.formatted_profit_revive_from = `${this.reviveSelectedYear}-${String(monthIndex + 1).padStart(2, '0')}`;
                this.fdata.profit_revive_from = this.formatted_profit_revive_from + "-01";
                this.revive_show_picker = false; // Hide the picker after selecting a date
            },
            handleClickOutside(event) {
                // Hide the picker if the click is outside the picker wrapper
                if (this.showPicker && !this.$refs.pickerWrapper.contains(event.target)) {
                    this.showPicker = false;
                }

                if (this.revive_show_picker && !this.$refs.pickerWrapper.contains(event.target)) {
                    this.revive_show_picker = false;
                }
            },
            isMonthDisabled(monthIndex) {
                const year = this.minDate.getFullYear();
                // const month = String(this.minDate.getMonth() + 1).padStart(2, '0');
                const month = this.minDate.getMonth();
                return (this.selectedYear === year && monthIndex < month);
            },

            isReviveMonthDisabled(monthIndex) {
                const year = this.min_revive_date.getFullYear();
                // const month = String(this.min_revive_date.getMonth() + 1).padStart(2, '0');
                const month = this.min_revive_date.getMonth();
                console.log('isReviveMonthDisabled' + month + " " + monthIndex);
                return (this.reviveSelectedYear === year && monthIndex < month);
            },

            formatDate(dateString) {
                if (!dateString) return '';
                const date = new Date(dateString);
                return date.toLocaleString('en-US', { month: 'long', year: 'numeric' });
            },
            // End: Rejwan: 29-01-2025

            // Start: Rejwan: 24-03-2025
            showApproveModal: function(pageflg)
            {
                if(this.fdata.profit_waiver_from == null) {
                    this.$bvToast.toast('No date Selected!!', {
                                           title: 'Error!',
                                            variant: 'danger',
                                            solid: true
                                        });
                    return false;
                } else if(this.fdata.profit_revive_from == null && this.isWaiverDate==false) {
                    this.$bvToast.toast('No date Selected!!', {
                                           title: 'Error!',
                                            variant: 'danger',
                                            solid: true
                                        });
                    return false;
                }
                this.$bvModal.show('pass-modal');

            },

            submitForm() {
                this.$bvModal.hide('pass-modal'); // Close the modal
                console.log('yes yes');
                this.onSubmit(new Event('submit')); // Submit the form
            }
            // End: Rejwan: 24-03-2025

        },

        created: function(){
            this.getWaiverInfo(this.employee_info.employee_id);
        }
    }
</script>
<style scoped> /* Rejwan: 29-01-2025 */
.b-overlay-wrap.trz_overlay .b-overlay {
	height: 100%;
}
.loan-card-title {
   /* text-align: center; */
   padding-bottom: 10px;
   font-size: 16px;
   /* color: #00c5fb !important; */
}

.loan_card_wrapper {
   padding-top: 12px;
   padding-bottom: 12px;
}

/* Start: Rejwan: 29-01-2025 */
.custom-month-input::-webkit-calendar-picker-indicator {
    background-color: #004242;
    padding: 10px;
    border-radius: 10%;
}

/* For Firefox */
.custom-month-input::-moz-calendar-picker-indicator {
    background-color: #004242;
    padding: 10px;
    border-radius: 10%;
}

  /* For Internet Explorer */
.custom-month-input::-ms-clear {
    background-color: #004242;
    padding: 10px;
    border-radius: 10%;
}

/* date-picker button */
.date-picker {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  cursor: pointer;
  background-color: #fff;
  min-width: 200px;
  text-align: left;
  font-family: Arial, sans-serif;
  transition: border-color 0.3s;
  position: relative;
}

.date-picker:hover {
  border-color: #007BFF;
}

.date-picker::after {
  content: "▼";
  float: right;
  color: #666;
  margin-right: 5px;
}

/* Picker Container */
.picker-container {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 5px;
  z-index: 10;
  position: absolute;
}

/* Header (Year Navigation) */
.picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

button {
  background-color: #007BFF;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

/* Month Grid */
.months-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.months-grid div {
  padding: 10px;
  background-color: #f1f1f1;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.months-grid div:hover {
  background-color: #dcdcdc;
}

.months-grid div.selected {
  background-color: #007BFF;
  color: white;
}

/* To prevent overflow issues */
.month-year-picker {
  position: relative;
}

.disabled {
    pointer-events: none;
    opacity: 0.5;
}

.disabled-button {
    background-color: #ccc !important;
    cursor: not-allowed !important;
}
/* End: Rejwan: 29-01-2025 */

</style>
